export type PosthogExceptionFrame = {
  function?: string;
  mangled_name?: string;
  resolved_name?: string;
  filename?: string;
  abs_path?: string;
  source?: string;
  in_app?: boolean;
};

export type PosthogExceptionEntry = {
  value?: string;
  type?: string;
  $exception_message?: string;
  $exception_type?: string;
  stacktrace?: { frames?: Array<PosthogExceptionFrame> };
};

function isOptionalString(value: unknown): value is string | undefined {
  return value === undefined || typeof value === "string";
}

export function isPosthogExceptionEntry(
  value: unknown,
): value is PosthogExceptionEntry {
  if (typeof value !== "object" || value === null) return false;
  const entry: Record<string, unknown> = { ...value };
  return (
    isOptionalString(entry.value) &&
    isOptionalString(entry.type) &&
    isOptionalString(entry.$exception_message) &&
    isOptionalString(entry.$exception_type) &&
    (entry.stacktrace === undefined ||
      (typeof entry.stacktrace === "object" && entry.stacktrace !== null))
  );
}

export function toPosthogExceptionList(
  value: unknown,
): Array<PosthogExceptionEntry> {
  return Array.isArray(value) ? value.filter(isPosthogExceptionEntry) : [];
}

export type ExceptionFrameNameFields = {
  function?: string;
  mangled_name?: string;
  resolved_name?: string;
};

export function exceptionValue(first: PosthogExceptionEntry): string {
  return first.value ?? first.$exception_message ?? "";
}

export function frameNameIncludes(
  frame: ExceptionFrameNameFields,
  needle: string,
): boolean {
  return [frame.function, frame.mangled_name, frame.resolved_name].some(
    (name) => name?.includes(needle),
  );
}
